import { PhotoECardPreviewWrapper } from './PhotoECardPreviewWrapper';

export default PhotoECardPreviewWrapper;
